import FetchFailedError from "../../fetchers/FetchFailedError";
import { getToken, TOKEN_USER_KEY } from "../../token";
import {
  getServiceBaseUrl,
  serviceUrlKeys
} from "../../utils/reduxMiddleware/extractServiceBaseUrls";
import MaterialListServiceHttpError from "./MaterialListServiceHttpError";

export const mutator = async <ResponseType>(
  url: string,
  options: RequestInit
) => {
  const { method, headers: requestHeaders } = options;

  const baseUrl = getServiceBaseUrl(serviceUrlKeys.materialList);

  const userToken = getToken(TOKEN_USER_KEY);
  const authHeaders = userToken
    ? ({ Authorization: `Bearer ${userToken}` } as object)
    : {};

  const headers = {
    ...requestHeaders,
    ...authHeaders,
    "Accept-Version": "2"
  };

  const serviceUrl = `${baseUrl}${url}`;

  try {
    const response = await fetch(serviceUrl, {
      ...options,
      headers
    });

    if (!response.ok) {
      throw new MaterialListServiceHttpError(
        response.status,
        response.statusText,
        serviceUrl
      );
    }

    // Return the response body in JSON format if the method is GET.
    if (method === "GET") {
      try {
        return (await response.json()) as ResponseType;
      } catch {
        throw new Error("The response body contains invalid JSON");
      }
    }
  } catch (error) {
    if (error instanceof MaterialListServiceHttpError) {
      throw error;
    }

    const message = error instanceof Error ? error.message : "Unknown error";
    throw new FetchFailedError(message, serviceUrl);
  }

  // Do nothing. Some of our responses are intentionally empty and thus
  // cannot be converted to JSON. Fetch API and TypeScript has no clean
  // way for us to identify empty responses so instead we swallow
  // syntax errors during decoding.
  return null as ResponseType;
};

export default mutator;

export type ErrorType<ErrorData> = ErrorData & { status: number };

export type BodyType<BodyData> = BodyData & { headers?: unknown };
